import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AutoSect from './components/AutoSect.vue'
import BanksSect from './components/BanksSect.vue'
import CaseSect from './components/CaseSect.vue'
import ConnectSect from './components/ConnectSect.vue'
import ForWhomSect from './components/ForWhomSect.vue'
import HeaderSect from './components/HeaderSect.vue'
import HowSect from './components/HowSect.vue'
import OrderSect from './components/OrderSect.vue'
import RateSect from './components/RateSect.vue'
import SecureSect from './components/SecureSect.vue'
import SoonSect from './components/SoonSect.vue'
import { store } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

store.getGajetWidth()

window.addEventListener('resize', () => {
  store.getGajetWidth()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderSect),
    _createElementVNode("main", null, [
      _createVNode(OrderSect),
      _createVNode(HowSect),
      _createVNode(AutoSect),
      _createVNode(BanksSect),
      _createVNode(ForWhomSect),
      _createVNode(CaseSect),
      _createVNode(RateSect),
      _createVNode(SoonSect),
      _createVNode(SecureSect),
      _createVNode(ConnectSect)
    ])
  ], 64))
}
}

})